export interface TimeRange { date: string; startTime: string; endTime: string; }

/** Convierte 'HH:MM' o 'HH:MM:SS' a minutos desde medianoche. */
function toMinutes(time: string): number {
  const [h, m] = time.split(':');
  return Number(h) * 60 + Number(m);
}

/**
 * Cruce = misma fecha + intervalos [start, end) que se intersectan.
 * El toque exacto (fin de uno = inicio del otro) NO es cruce.
 * Fechas distintas nunca cruzan.
 */
export function rangesOverlap(a: TimeRange, b: TimeRange): boolean {
  if (a.date !== b.date) return false;
  return (
    toMinutes(a.startTime) < toMinutes(b.endTime) &&
    toMinutes(b.startTime) < toMinutes(a.endTime)
  );
}

/** Devuelve índices de `candidates` que se cruzan con `existing`. */
export function findOverlaps(existing: TimeRange[], candidates: TimeRange[]): number[] {
  const indices: number[] = [];
  candidates.forEach((candidate, i) => {
    if (existing.some((e) => rangesOverlap(e, candidate))) indices.push(i);
  });
  return indices;
}
